import { z } from "zod";

export const InsertTypeList = [
  "beforebegin",
  "afterbegin",
  "beforeend",
  "afterend",
] as const;
export type InsertType = (typeof InsertTypeList)[number];

export const OnsiteEditDtoSchema = z.object({
  id: z.string().uuid(),
  variationId: z.string().uuid(),
  find: z.string().nullable(),
  title: z.string().nullish(),
  isRegex: z.boolean().default(false),
  replace: z.string().default(""),
  querySelectors: z.string().array().default([""]),
  skip: z.boolean().default(false),
  remove: z.boolean().default(false),
  groupId: z.string().optional(),
  isHtml: z.boolean().default(false),
  isImage: z.boolean().default(false),
  insertType: z.enum(InsertTypeList).nullable(),
  createdAtUrl: z.string().optional().nullable(),
});
export type OnsiteEditDto = z.infer<typeof OnsiteEditDtoSchema>;
